import {FC, useEffect, useState} from 'react'
import { KTSVG } from '../../../_metronic/helpers/components/KTSVG'
import { useSelector } from 'react-redux';

const ViewNotification: FC = () => {
  const notifications: Array<any> = useSelector((state: any) => state.core.notifications);
  const [selectedId, setSelectedId]: any = useState(null)
  const [notification, setNotification]: any = useState(null)

  useEffect(() => {
    const modalElement = document.getElementById("View_Notification")
        modalElement?.addEventListener('show.bs.modal', (event: any) => {
            const link = event.relatedTarget
            const id = link.getAttribute('data-id')
            setSelectedId(id)
        })
  }, []);

  useEffect(() => {
    const msg:any = notifications?.find((m:any) => m?.id === selectedId)
    setNotification(msg)
  }, [selectedId]);

  return (
    <div className='modal fade' id='View_Notification' aria-hidden='true'>
      <div className='modal-dialog modal-dialog-centered mw-600px'>
        <div className='modal-content'>
          <div className='modal-header pb-0 border-0 justify-content-end'>
            <div className='btn btn-sm btn-icon btn-active-light-dark' data-bs-dismiss='modal'>
              <KTSVG path='/assets/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
            </div>
          </div>
          <div className='modal-body px-lg-10 mb-10'>
          <div className="text-center mb-10">
              <h1 className="mb-3">System Updates</h1>
              <div className="text-muted fw-semibold fs-7 mb-13">
                Stay informed about new features, latest improvements <br/> and security enhancements.
              </div>
          </div>
          <div className='px-lg-10 mb-20 text-gray-700'>
          <p style={{whiteSpace: 'pre-wrap'}}>
            {notification?.message}
          </p>
          </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { ViewNotification }
